//const fetch = require("node-fetch").default;
/*eslint no-proto: "error"*/

//import fetch from "../global/node-fetch.js";
//import fetch from "node-fetch";
import "whatwg-fetch";

var strShorten = require("str_shorten");

var Youtube = {
  defaultOpt: {
    max: false,
    thumbnails: "medium",
    titleMax: 40,
    title: true
  },
  opt: {},

  getVideosFromPlaylist: function(opt) {
    Lc.f("getVideosFromPlaylist");
    this.opt = _.extend(this.defaultOpt, opt);

    //const playlistID = this.opt.playlistID;
    //const apiKey = this.opt.apiKey;

    /*
       const url = process.env.NODE_ENV=='development' ?
        'https://php7.tld/shoptet/5m/shoptet/all/theme/dist/videa.json' :
        `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2C%20id&maxResults=20&playlistId=${playlistID}&key=${apiKey}`;

        https://file.corux.cz/save-file/?id=9&token=da0863ba8b140244e55604d985c182ba8e56bf9e

        */
    let lngPrefix = Top.jazyk == "cs" ? "" : "_" + Top.jazyk;
    const url =
      window.location.origin +
      "/user/documents/ladzo/files/yuotube" +
      lngPrefix +
      ".json?v=" +
      new Date().formatyyyymmdd() +
      "&razitko=" +
      Top.razitko;
    Lc.log("url", url);

    return fetch(url)
      .then(res => res.json())
      .then(json => Youtube.prms_getContainerForVideos(json))
      .catch(error => {
        Lc.ctch(error);
      });
  },

  prms_getContainerForVideos: function(json) {
    Lc.promise("prms_getContainerForVideos");

    return new Promise(function(resolve) {
      let videa = get(json, "items") || false;
      if (!videa) throw "nenalezena žádná videa";

      Lc.log("videa", videa);

      let $kod = "";
      let x = 0;

      for (let entry of videa) {
        if (Youtube.opt.max && ++x > Youtube.opt.max) break;

        Lc.log(entry);
        Lc.log("id", entry.snippet.resourceId.videoId);

        let urlImage = entry.snippet.thumbnails[Youtube.opt.thumbnails].url;

        let strong = "";
        if (Youtube.opt.title) {
          let title = strShorten(entry.snippet.title, Youtube.opt.titleMax);
          strong = `<strong>${title}</strong>`;
        }

        let $v = `${strong}  \
                 <div class="youtube"   \
                 id="${entry.snippet.resourceId.videoId}"  \
                 data-params="modestbranding=1&showinfo=0&controls=1&vq=hd720" \
                 style="background-image:url(${urlImage})" >\
            </div>`;

        $kod += el("div.dvYt", $v);
      }

      $kod = el("div.dvYvid>.flx", $kod);

      return resolve($kod);
    });
  },

  showYoutubeVideos: function() {
    $(".dvYvid .youtube").each(function() {
      // Based on the YouTube ID, we can easily find the thumbnail image
      //$(this).css('background-image', 'url(http://i.ytimg.com/vi/' + this.id + '/mqdefault.jpg)');
      //"https://i.ytimg.com/vi/nyRpbuaWm10/mqdefault.jpg"
      // Overlay the Play icon to make it look like a video player

      $(this).append(
        '<div class="play"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#212121" fill-opacity="0.8"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></div>'
      );
    });

    $(".dvYvid div.youtube").click(function() {
      //var strong=$(this).find('strong');

      var iframe_url =
        "https://www.youtube.com/embed/" + this.id + "?autoplay=1&autohide=1";
      if ($(this).data("params")) iframe_url += "&" + $(this).data("params");

      // The height and width of the iFrame should be the same as parent
      var iframe = $("<iframe/>", {
        frameborder: "0",
        width: "320",
        height: "180",
        allowfullscreen: true,
        src: iframe_url
      });

      // Replace the YouTube thumbnail with YouTube HTML5 Player
      $(this).replaceWith(iframe);
    });
  },

  _init: function() {}
};

Youtube._init();

export { Youtube };
